module.exports = __webpack_public_path__ + "static/media/moneyou.6a908729.png";